<template>
  <!-- mini statistic start -->
  <v-col :cols="12" :sm="12" :lg="12">
    <v-card>
      <v-card-title>
        <router-link :to="{ name: 'admin_users_form' }">
          <v-btn fab class="mt-n4" color="blue">
            <v-icon color="white">mdi-plus</v-icon>
          </v-btn>
        </router-link>

        <p class="pl-6">{{ $tc("user.title", 2) }}</p>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          :label="$t('common.search')"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="users"
        :loading="loading"
        item-key="id"
        class="elevation-1"
        :footer-props="footer"
        :loading-text="$t('common.loading')"
        :no-results-text="$t('common.no_results')"
        :options.sync="options"
        :server-items-length="$store.state.user.totalCount"
        dense
      >
        <template v-slot:no-data>
          {{ $t("common.no_results") }}
        </template>
        <template #item.actions="{ item }">
          <v-btn small icon @click.prevent="remove(item)">
            <v-icon small>delete</v-icon>
          </v-btn>
        </template>
        <template #item.first_name="{ item }">
          {{ item.first_name | capitalize | truncate(20) }}
        </template>
        <template #item.email="{ item }">
          {{ item.email | truncate(20) }}
        </template>
        <template #item.last_name="{ item }">
          {{ item.last_name | capitalize | truncate(20) }}
        </template>
        <template #item.squad="{ item }">
          <span v-if="item.squad">{{
            item.squad.name | capitalize | truncate(20)
          }}</span>
        </template>
        <template #item.archived="{ item }">
          <span v-if="item.archived">{{ $t("common.yes") }}</span>
          <span v-else>{{ $t("common.no") }}</span>
        </template>
        <template #item.role="{ item }">
          {{ $t("common.role." + item.role.toLowerCase()) }}
        </template>

        <template #item.actions="{ item }">
          <div class="d-flex">
            <router-link
              :to="{
                name: 'admin_users_form_edit',
                params: { user_id: item.id },
              }"
            >
              <v-img src="/icons/crayon.png" width="30" class="mr-2" />
            </router-link>
            <v-img
              src="/icons/delete.png"
              max-width="30"
              class="mr-2"
              @click.prevent="remove(item)"
            />
          </div>
        </template>
      </v-data-table>
    </v-card>
  </v-col>
</template>

<script>
import { createNamespacedHelpers } from "vuex"

const { mapActions } = createNamespacedHelpers("user")
import { FETCH } from "@/store/action-types"
import { debounce } from "@/utils/helper"

export default {
  data: () => ({ loading: false, search: "", options: {} }),
  mounted() {
    this.getDataFromApi()
  },
  computed: {
    users() {
      return this.$store.state.user.data
    },
    footer() {
      return {
        "items-per-page-all-text": this.$t("pagination.all"),
        "items-per-page-text": this.$t("pagination.row_per_page"),
        itemsPerPageText: this.$t("pagination.row_per_page"),
        pageText: "{0}-{1} sur {2}",
      }
    },
    headers() {
      return [
        {
          value: "first_name",
          text: this.$tc("user.first_name", 1),
          align: " text-no-wrap",
        },
        {
          value: "last_name",
          text: this.$tc("user.last_name", 1),
          align: " text-no-wrap",
        },
        {
          value: "email",
          text: this.$tc("user.email", 1),
          align: " text-no-wrap",
        },
        {
          value: "year",
          text: this.$tc("user.year", 1),
          align: " text-no-wrap",
        },
        {
          value: "squad",
          text: this.$tc("user.squad", 1),
          width: "20%",
        },
        {
          value: "role",
          text: this.$t("common.role.title"),
          width: "15%",
        },
        {
          value: "archived",
          text: this.$t("user.archived"),
          width: "5%",
        },
        {
          value: "actions",
          align: "right",
          width: "1%",
        },
      ]
    },
  },
  methods: {
    debounceFetchApi: debounce(function () {
      this.getDataFromApi()
    }, 1000),
    getDataFromApi() {
      this.loading = true
      const { page, itemsPerPage, sortBy, sortDesc } = this.options
      this.FETCH({
        offset: (page - 1) * itemsPerPage,
        limit: itemsPerPage,
        ...(this.search && {
          keyword: this.search,
        }),
        ...(sortBy &&
          sortBy.length && {
            sort_field: sortBy[0],
            sort: sortDesc[0] ? "desc" : "asc",
          }),
      })
        .then((data) => {
          this.items = data.items
          this.loading = false
        })
        .finally(() => {
          self.loading = false
        })
    },
    async remove(item) {
      if (!confirm(this.$t("common.delete_confirm"))) {
        return
      }
      try {
        await this.$store.dispatch("user/DELETE", item)
      } catch (err) {
        return
      }
      this.$toast.success(this.$t("success.item_deleted"))
    },
    ...mapActions([FETCH]),
  },
  watch: {
    options(val, oldVal) {
      if (Object.keys(oldVal).length !== 0) {
        this.getDataFromApi()
      }
    },
    search() {
      this.debounceFetchApi()
    },
  },
}
</script>
